/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Laravel
 * OpenAPI spec version: 0.0.1
 */

/**
 * | |
 * |---|
 * | `not_submitted` <br/>  |
 * | `pending_review` <br/>  |
 * | `changes_requested` <br/>  |
 * | `graded` <br/>  |
 * | `graded_with_retry` <br/>  |
 * | `reopened` <br/> Set by a teacher who reopens a submitted task without grading it. Open for the student (editable, listed under "Open taken"), invisible to both teacher assessment tabs until the student resubmits. |
 */
export type AssessmentStatus = typeof AssessmentStatus[keyof typeof AssessmentStatus];


export const AssessmentStatus = {
  not_submitted: 'not_submitted',
  pending_review: 'pending_review',
  changes_requested: 'changes_requested',
  graded: 'graded',
  graded_with_retry: 'graded_with_retry',
  reopened: 'reopened',
} as const;
